import React, {
  Fragment,
  useEffect,
  useRef,
  useMemo,
  useState,
  useCallback,
} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ListItemText from "@mui/material/ListItemText";
import ListItemButton from "@mui/material/ListItemButton";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Tooltip } from '@mui/material';

import Slide from "@mui/material/Slide";
import {
  Box,
  FormControlLabel,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Select,
  Switch,
  TextField,
  Typography,
  FormControl,
  InputLabel,
  MenuItem,
} from "@mui/material";

import { IoMdClose } from "react-icons/io";

import PropTypes from "prop-types";

import parse from "html-react-parser";
import axios from "axios";
import axiosInstance from "../CommonGlobals/axiosInstance.js";
import { orderBy, set } from "lodash";
import {
  MdArrowBack,
  MdArrowForward,
  MdClose,
  MdFemale,
  MdMale,
  MdInfo
} from "react-icons/md";

import { BiMale } from "react-icons/bi";
import { FaFemale } from "react-icons/fa";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import {
  useForm,
  Controller,
  useFieldArray,
  FormProvider,
} from "react-hook-form";

import { usePath } from "../CommonGlobals/PathContext";

import { GiSteeringWheel } from "react-icons/gi";
import { MdOutlineScreenRotationAlt } from "react-icons/md";

import SeatLayoutHorizontalSkeleton from "../CommonGlobals/SeatLayoutHorizontalSkeleton";
import { CiLocationArrow1, CiLocationOn, CiPhone } from "react-icons/ci";
import { TbView360, TbView360Number } from "react-icons/tb";
import { HiClipboardCopy } from "react-icons/hi";
import { FaRegCopy } from "react-icons/fa6";

import { useAppGlobalState } from "../CommonGlobals/Store";
import ComponentLevelLoader from "../CommonGlobals/ComponentLevelLoader.jsx";

import PlatformDetector from "../CommonGlobals/PlatformDetector";
import { MISBookingMode } from "../CommonGlobals/TRMISBookingMode";

import { getPgSelectorUrlString } from "../CommonGlobals/PGSelector.js";
import { sendEventTobackend } from "../CommonGlobals/sendEventDataTobackend";
import ContactPhone from "./ContactPhone.jsx";

const customTheme = createTheme({
  palette: {
    theme: {
      primary: "#1F1F1F", // Blue color
      secondary: "#3D18B5", // Blue color
      button: "#F4CC08", // Blue color
    },
  },
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      hidden={value !== index}
      {...other}
      style={{ padding: 0 }}
    >
      <Box sx={{ p: 1, display: value === index ? "block" : "none" }}>
        {children}
      </Box>
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const JourneyDailog = ({
  dailogInputData = {
    journeyDataUrl: "/seatArrangementdirectdata.json",
  },
  open = false,
  currentTab = 0,
  dialogClose,
  paymentUrl = "/payments",
}) => {
  const [globalData, setGlobalData] = useAppGlobalState();

  //const [dailogOpen, setDailogOpen] = useState(open);
  const [tabValue, setTabValue] = useState(currentTab);
  // const fromDateRef = useRef();
  const [layoutdata, setLayoutData] = useState(null);

  const [layoutsList, setLayoutsList] = useState(null);

  const [layoutsArrayData, setLayoutsArrayData] = useState(null);

  const [parsedData, setParsedData] = useState(null);

  const [isLayoutDataLoading, setIsLayoutDataLoading] = useState(false);

  const [pickupPoints, setPickupPoints] = useState(null);
  const [droppingPoints, setDroppingPoints] = useState(null);

  const [selectedBoarding, setSelectedBoarding] = useState(null);
  const [selectedDropping, setSelectedDropping] = useState(null);

  const [selectedBoardingName, setSelectedBoardingName] = useState(null);
  const [selectedDroppingName, setSelectedDroppingName] = useState(null);

  const [selectedSeats, setSelectedSeats] = useState([]);

  const [subtotal, setSubTotal] = useState(0);
  const [gstInpercent, setGstInpercent] = useState(null);
  const [totalGst, setTotalGst] = useState(0);
  const [discount, setDiscount] = useState(0);

  const [discountInPercent, setDiscountInPercent] = useState(0);

  const [grandTotal, setGrandTotal] = useState(0);
  const [grandwithoutDisc, setGrandwithoutDisc] = useState(0);

  const [selectedGender, setSelectedGender] = useState("Male");
  const [updatedSeats, setUpdatedSeats] = useState([]);

  const { paths } = usePath();

  const [currentJourneyId, setCurrentJourneyId] = useState(null);
  const [currentJourneyType, setCurrentJourneyType] = useState("ONWARD");
  const [currentCoachId, setCurrentCoachId] = useState(null);
  const [currentFromCityId, setCurrentFromCityId] = useState(null);
  const [currentToCityId, setCurrentToCityId] = useState(null);

  const [layoutOrientation, setLayoutOrientation] = useState(1);
  const [layoutDisplayCssClass, setLayoutDisplayCssClass] = useState(1);

  const [seatsBookedList, setSeatBookedList] = useState(null);
  const [allSeatDeatils, setAllSeatDeatils] = useState(null);

  const [layoutObject, setLayoutObject] = useState(null);
  const [frompayload, setFormPayload] = useState(null);

  const formref = useRef();

  const [onwardDateFormatWithMonthName, setOnwardDateFormatWithMonthName] =
    useState();
  const [onwardDayName, setOnwardDayname] = useState();

  const [returnDateFormatWithMonthName, setReturnDateFormatWithMonthName] =
    useState();
  const [returnDayName, setReturnDayname] = useState();

  const [isSeatFlipped, setIsSeatFlipped] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const [deviceType, setDeviceType] = useState(0);

  const [MISBookingModeState, setMISBookingModeState] = useState(0);
  const [pgselectorUrl, setPgselectorUrl] = useState("");

  const [isTermsAndConditionsChecked, setIsTermsAndConditionsChecked] =
    useState();



      const dialogContentRef = useRef(null);
      const boardingListRefOnward = useRef(null);
      const droppingListRefOnward = useRef(null);
      const boardingListRefReturn = useRef(null);
      const droppingListRefReturn = useRef(null);
      const passengerSectionRef = useRef(null);

  // set up global values

  // console.log(globalData);

  useEffect(() => {
    if (dialogContentRef.current) {
       
      console.log("dialog content ref is available");
      dialogContentRef.current.scrollTop = 0;

    }
   
    console.log("dialog Content Ref is " + dialogContentRef.current);
  },[tabValue]);

  useEffect(() => {
    //console.log("Journey type in dailog is " + JSON.stringify(globalData));
    console.log(globalData); 
  }, [globalData]);

  useEffect(() => {
    //console.log(isTermsAndConditionsChecked);
  }, [isTermsAndConditionsChecked]);

  useMemo(() => {
    const onwarddate = globalData.onwardDate;
    const returndate = globalData.returnDate;
    //console.log("Global Dat is" + JSON.stringify(globalData));
    let result_with_slash = onwarddate.replace(/-/g, "/");
    let result = result_with_slash.replace(/\/\s*-/g, "-");
    const parts = result.split(/\D+/);

    //  console.log(parts);
    var day = parseInt(parts[0]);
    var month = parseInt(parts[1]);
    var year = parseInt(parts[2]);

    var dateObject = new Date(year, month - 1, day);
    // console.log(dateObject);
    const options = { month: "short" };
    const monthName = new Intl.DateTimeFormat("en-US", options).format(
      dateObject,
    );

    const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
    const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(
      dateObject,
    );
    // console.log("Day:", dayName);
    setOnwardDateFormatWithMonthName(`${day}-${monthName}-${year}`);
    setOnwardDayname(dayName);

    if (
      returndate != null &&
      returndate != undefined &&
      returndate.trim() != ""
    ) {
      let result_with_slash = returndate.replace(/-/g, "/");
      let result = result_with_slash.replace(/\/\s*-/g, "-");
      const parts = result.split(/\D+/);

      //  console.log(parts);
      var day_ret = parseInt(parts[0]);
      var month_ret = parseInt(parts[1]);
      var year_ret = parseInt(parts[2]);

      var dateObject_ret = new Date(year_ret, month_ret - 1, day_ret);
      // console.log(dateObject);
      const options = { month: "short" };
      const monthName = new Intl.DateTimeFormat("en-US", options).format(
        dateObject_ret,
      );

      const dayOptions = { weekday: "long" }; // "short" → Mon, Tue; "narrow" → M, T
      const dayName = new Intl.DateTimeFormat("en-US", dayOptions).format(
        dateObject_ret,
      );
      // console.log("Day:", dayName);
      setReturnDateFormatWithMonthName(`${day_ret}-${monthName}-${year_ret}`);
      setReturnDayname(dayName);
    }
  }, []);

  useEffect(() => {
    //console.log("Platform Detector Info:");
   // console.log(PlatformDetector.getUserAgent());

    const TrviaAndMisData = MISBookingMode();
    setDeviceType(TrviaAndMisData.deviceType);
    setMISBookingModeState(TrviaAndMisData.MISBookingMode);

    // if (PlatformDetector.isDesktop()) {
    //           setDeviceType(21);
    //           setMISBookingMode(1); // desktop mode

    //         } else if (PlatformDetector.isMobile) {
    //           if (PlatformDetector.isAndroidWebView()) {
    //             setDeviceType(31); // android webview
    //             setMISBookingMode(2); // mobile android webview mode
    //           } else if (PlatformDetector.isIOSWebView()) {
    //             setDeviceType(41); // ios webview
    //              setMISBookingMode(2); // mobile ios webview mode
    //           } else {
    //             if (PlatformDetector.isAndroid()) {
    //               setDeviceType(22); // android browser
    //               setMISBookingMode(1); // mobile android webview mode
    //             } else if (PlatformDetector.isIOS()) {
    //               setDeviceType(22); // ios browser
    //               setMISBookingMode(1); // mobile ios webview mode
    //             } else {
    //               setDeviceType(23);
    //               setMISBookingMode(1); // mobile ios webview mode// other mobile browser
    //             }
    //           }
    //         } else if (PlatformDetector.isTablet()) {
    //           if (PlatformDetector.isAndroidWebView()) {
    //             setDeviceType(8); // android webview
    //             setMISBookingMode(2);
    //           } else if (PlatformDetector.isIOSWebView()) {
    //             setDeviceType(9); // ios webview
    //             setMISBookingMode(3);
    //           } else {
    //             if (PlatformDetector.isAndroid()) {
    //               setDeviceType(23);
    //               setMISBookingMode(1); // android browser
    //             } else if (PlatformDetector.isIOS()) {
    //               setDeviceType(23); // ios browser
    //               setMISBookingMode(1);
    //             } else {
    //               setDeviceType(22);
    //               setMISBookingMode(1); // other mobile browser
    //             }
    //           }
    //         } else {
    //           setDeviceType(23); // unknown
    //           setMISBookingMode(1);
    //         }
  }, []);

  useEffect(() => {
    //console.log("detected device type is " + deviceType);
  }, [deviceType]);

  // end of global values

  // useEffect(()=>{
  //     console.log(globalData);
  // },[globalData]);

  //console.log(paths);

  useEffect(() => {
    // console.log("paths content");
    // console.log(paths);
  }, [paths]);
  useEffect(() => {
    if (layoutOrientation == 1) {
      fetchLayoutData();
      setLayoutDisplayCssClass("layout-deck-content");
    } else {
      if (layoutOrientation == 2) {
        fetchLayoutData();
        setLayoutDisplayCssClass("layout-deck-content-vertical");
      }
    }
  }, [layoutOrientation]);

  // passenger details payload creation

  const [contactDetails, setContactDetails] = useState({
    mobile: globalData?.SignedPassenger?.IsPassengerSignedIn ? globalData?.SignedPassenger?.SignedPassenger?.MobileNumber :"",
    email: "",
  });

  // --- react-hook-form setup ---
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    getValues,
    watch,

    formState: { errors, isValid },
  } = useForm({
    shouldFocusError: true,
    mode: "onChange",
    // live validation while typing
    defaultValues: {
      mobile: contactDetails.mobile ||  "",
      email: contactDetails.email || "",
      passengers: updatedSeats.map((s) => ({
        passangerName: s.passangerName || "",
        age: s.age || "",
        gender: s.gender,
      })),
      GSTNumber:""
    },
  });

  useEffect(() => {
    // console.log(frompayload);
    // console.log(formref.current);
    if (frompayload != null && formref.current) {
      formref.current.submit();
    }
  }, [frompayload]);

  useEffect(() => {
    const current = getValues(); // retrieve existing mobile/email if any
    reset({
      mobile: current.mobile || contactDetails.mobile || "",
      email: current.email || contactDetails.email || "",
      passengers: updatedSeats.map((s) => ({
        passangerName: s.passangerName || "",
        age: s.age || "",
      })),
    });
  }, [updatedSeats]); // eslint-disable-line react-hooks/exhaustive-deps

  // watch for mobile/email live changes (if you want to keep local contactDetails in sync)
  useEffect(() => {
    const subscription = watch((values) => {
      // optional: update local contactDetails state if you rely on it elsewhere
      setContactDetails((prev) => ({
        ...prev,
        mobile: values.mobile ?? prev.mobile,
        email: values.email ?? prev.email,
      }));
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  // end of passenger detials
  // const handleContactChange = (field, value) => {
  //     setContactDetails((prev) => ({ ...prev, [field]: value }));
  //     console.log(field);
  //     console.log(value);
  // };

  const tabstyles = useMemo(
    () => ({
      color: "#1f1f1f",
      fontWeight: 500,
      fontSize: "13px",
      textTransform: "capitalize",
      padding: "0px 10px",
      height: "35px",
      minHeight: "35px",
      "&.Mui-selected": {
        backgroundColor: "#2D3FA8",
        color: "#fff",
      },
    }),
    [],
  );

  const tabsStyle = useMemo(() => ({ height: "35px", minHeight: "35px" }), []);
  // const handleClose = () => {
  //   setDailogOpen(false);
  // };

  const handleClose = () => {
    dialogClose({ lastDailogOpenValue: false });
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  // useEffect(() => {
  //   setDailogOpen(open);
    
  // }, [open]);

  // useEffect(() => {
  //   dialogClose({ lastDailogOpenValue: dailogOpen });
  // }, [dailogOpen]);

  useEffect(() => {
    setTabValue(currentTab);
  }, [currentTab]);

  useEffect(() => {
    console.log("dailog input data changed is testing");
    console.log(dailogInputData);
    if (dailogInputData?.bus) {
      //  console.log(dailogInputData?.bus);
      
      setPickupPoints(dailogInputData?.bus.Boardings);
      setDroppingPoints(dailogInputData?.bus.Droppings);
      setGstInpercent(parseFloat(dailogInputData?.bus.GSTPercent));
      setDiscountInPercent(parseFloat(dailogInputData?.bus.DiscountPercent));
      fetchLayoutDataAll();

      sendEventTobackend( "ViewSeatsClicked", null , 1);
    }
  }, [dailogInputData]);

  const fetchLayoutDataAll = useCallback(async () => {
    console.log("paths at fetch time:", paths);
    const templayoutobject = {};
    // console.log("preparing layout data...");
    // console.log(dailogInputData);
    setIsLayoutDataLoading(true);
    if (dailogInputData != null || dailogInputData != undefined) {
      if (dailogInputData.bus != null || dailogInputData.bus != undefined) {
        setCurrentJourneyId(dailogInputData.bus.JourneyID);
        setCurrentCoachId(dailogInputData.bus.CoachID);
        setCurrentFromCityId(dailogInputData.bus.BFCityID);
        setCurrentToCityId(dailogInputData.bus.BTCityID);
        const layouturlpoint =
          paths.layouturl +
          `?CoachID=${dailogInputData.bus.CoachID}&LayoutType=${layoutOrientation}`;
        // console.log(layouturlpoint);
        const layoutstatusurlpoint =
          paths.journeySeatsInfo +
          `?CoachID=${dailogInputData.bus.CoachID}&JourneyID=${dailogInputData.bus.JourneyID}&FromCityID=${dailogInputData.bus.BFCityID}&ToCityID=${dailogInputData.bus.BTCityID}`;
        // console.log(layoutstatusurlpoint);
        try {
          const res1 = await axios.get(`/${layoutstatusurlpoint}`);
          const firstResult = res1.data;
          //  console.log("First Result");
          //  console.log(firstResult);
          const parsed_first_result = JSON.parse(res1.data.ResponseData);
          //  console.log("firstResult parsed");
          //  console.log(parsed_first_result);
          if (parsed_first_result) {
            templayoutobject.seatBookedLists =
              parsed_first_result.seatBookedLists;
            templayoutobject.AllSeatDeatils =
              parsed_first_result.AllSeatDeatils;
          }

          const res2 = await axios.get(`/${layouturlpoint}`);
          const secondResult = res2.data;
          //  console.log("second result");
          //  console.log(secondResult);
          if (secondResult.Status) {
            const parsed_second_result = JSON.parse(res2.data.ResponseData);
            //  console.log(parsed_second_result);
            templayoutobject.LayoutStr = parsed_second_result.LayoutStr;
            templayoutobject.SeatIDs = parsed_second_result.SeatIDs;
          } else {
            alert("Layout string data not available");
            return;
          }

          //  console.log(templayoutobject);
          setLayoutObject(templayoutobject);
        } catch (err) {
          console.error("Error in chained calls:", err);
        }
      } else {
        alert("Dailog data has no bus data ");
      }
    } else {
      alert("Dailog data is not available...");
    }
  });

  const [ltd, setLtd] = useState(null);
  const fetchLayoutData = useCallback(async () => {
    //  console.log("fetching layout data...");
    //  console.log(dailogInputData);
    if (dailogInputData != null || dailogInputData != undefined) {
      if (dailogInputData.bus != null || dailogInputData.bus != undefined) {
        // console.log(dailogInputData.bus);
        setCurrentJourneyId(dailogInputData.bus.JourneyID);
        setCurrentCoachId(dailogInputData.bus.CoachID);
        fetchLayoutStatusData();
        const layouturlpoint =
          paths.layouturl +
          `?CoachID=${dailogInputData.bus.CoachID}&LayoutType=${layoutOrientation}`;
        //  console.log(layouturlpoint);
        axios
          .get("/" + layouturlpoint)
          .then((response) => {
            //    console.log(response.data);
            if (response.data) {
              if (response.data.StatusCode != 1) {
                alert("Layout data not found");
              } else {
                const ltdata = response.data.ResponseData;
                try {
                  const parsedData = JSON.parse(ltdata);
                  //setLayoutData(parsedData.LayoutStr);
                  //    console.log(parsedData);
                  setLayoutsArrayData(parsedData.LayoutStr);
                } catch (e) {
                  alert("Error parsing layout data" + e.toString());
                  return;
                }

                // setLayoutData(response.data);
              }
            }
            //if (response.data) setLayoutData(response.data);
          })
          .catch((error) => {
            console.error("Error fetching layout data:", error);
          });
      }
    }
    // console.log(paths.layouturl);
    // const layouturlpoint = paths.layouturl + `?CoachID=${dailogInputData.bus.CoachID}&LayoutType=1`;
    // console.log(layouturlpoint);
    //  const res = await axios.get("/seatArrangementdirectdata.json");
    // console.log(res.data);
    // if (res.data) setLayoutData(res.data);
  });

  const fetchLayoutStatusData = useCallback(async () => {
    if (dailogInputData != null || dailogInputData != undefined) {
      if (dailogInputData.bus != null || dailogInputData.bus != undefined) {
        const layoutstatusurlpoint =
          paths.journeySeatsInfo +
          `?CoachID=${dailogInputData.bus.CoachID}&JourneyID=${dailogInputData.bus.JourneyID}&FromCityID=${dailogInputData.bus.BFCityID}&ToCityID=${dailogInputData.bus.BTCityID}`;
        //  console.log(layoutstatusurlpoint);
        const layoutstatusdata = axios
          .get(`/${layoutstatusurlpoint}`)
          .then((res) => {
            // console.log("layout status");
            // console.log(res.data);
            try {
              let responsedata = JSON.parse(res.data.ResponseData);
              // console.log(responsedata);
              setSeatBookedList(responsedata.seatBookedLists);
              setAllSeatDeatils(responsedata.AllSeatDeatils);
            } catch (e) {
              alert(
                "Layout seats status data is not parsed to json " +
                  e.toString(),
              );
            }
          });
        // console.log(layoutstatusdata);
      } else {
        alert("Layout data not yet ready to serve");
      }
    } else {
      alert("Layout data not yet ready to serve");
    }
  });

  useEffect(() => {
    // console.log("seat booked list ");
    // console.log(seatsBookedList);
  }, [seatsBookedList]);

  useEffect(() => {
    // console.log("all seats details");
    // console.log(allSeatDeatils);

    // moving from seatArrayData

    if (layoutsArrayData != null) {
      // console.log("layouts array data updated");
      if (Array.isArray(layoutsArrayData)) {
        if (layoutsArrayData.length > 0) {
          if (seatsBookedList && allSeatDeatils && allSeatDeatils.length > 0) {
            
            // /////////////////////////////////////////////!SECTION

            const seat_class =
              layoutOrientation === 1
                ? "horizontal-layout-seats-seat"
                : "vertical-layout-seats-seat";
            const templayoutslist = layoutsArrayData.map((layoutItem) => {
              if (
                layoutItem.HTMLString != null &&
                layoutItem.HTMLString != undefined
              ) {
                // console.log("layout item found");
                var idpattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-`;
                const rawString = layoutItem?.HTMLString.replace(
                  /##TDIDPREFIX##/g,
                  `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-`,
                );

                // console.log(rawString);

                const options = {
                  replace: (node) => {
                    if (node.type == "tag" && node.name == "td") {
                      //console.log(node);
                      // console.log(idpattern + "-tdSeatID_0");

                      let html_id = node.attribs.id;

                      const numberd_id = html_id.replace(
                        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
                        "",
                      );
                      const seatObject = [...allSeatDeatils];
                      let filteredSeat = seatObject.filter(
                        (item) => item.SeatID == numberd_id,
                      );
                      //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

                      let seat_to_pick =
                        filteredSeat?.length == 1 ? filteredSeat[0] : null;

                      return (
                        <td
                          rowSpan={node.attribs.rowspan}
                          colSpan={node.attribs.colspan}
                          style={{ minWidth: "40px" }}
                        >
                          {node.attribs.id === idpattern + "tdSeatID_0" ? (
                            <div> {node.children.map((p) => p.data)} </div>
                          ) : (
                            <div
                              className={`${
                                node.attribs.id === idpattern + "tdSeatID_0"
                                  ? "empty-seats"
                                  : layoutOrientation === 1
                                    ? node.attribs.rowspan == "3"
                                      ? "seat-vertical"
                                      : seat_class
                                    : node.attribs.colspan == "3"
                                      ? "seat-horizontal"
                                      : seat_class
                              } ${
                                checkIsSeatBooked(node.attribs.id) != null
                                  ? checkIsSeatBooked(node.attribs.id) == 1
                                    ? "booked-seat"
                                    : "women-seat"
                                  : checkSeatSelected(node.attribs.id)
                                    ? "seat-checked"
                                    : ""
                              }`}
                              onClick={() => {
                                if (checkIsSeatBooked(node.attribs.id)) {
                                  // console.log("No event attached");
                                } else {
                                  handleTdClick(node.attribs.id);
                                }
                              }}
                              id={node.attribs.id}
                            >
                              {/* <div style={{fontSize:"7px",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"1px"}}>
                                    <span > &#8377;{seat_to_pick.FARE} </span>
                                    <span>
                                      
                                    </span>
                                </div> */}
                              {checkIsSeatBooked(node.attribs.id) ? (
                                node.children.map((p) => p.data)
                              ) : (
                                <button
                                  class={`auto-seat-flip-button ${isSeatFlipped ? "flipped-seat" : ""}`}
                                >
                                  <span class="flip-seat-content text-seat-front">
                                    {" "}
                                    {node.children.map((p) => p.data)}{" "}
                                  </span>
                                  <span class="flip-seat-content text-seat-back">
                                    {" "}
                                    &#8377;{seat_to_pick.FARE}
                                  </span>
                                </button>
                              )}

                              <div className="slot"></div>
                            </div>
                          )}
                        </td>
                      );
                    }
                  },
                };

                const pdata = parse(rawString, options);

                return {
                  OrientationType: layoutItem.OrientationType,
                  DeckName: layoutItem.DeckName,
                  DeckDisplayOrder: layoutItem.DeckDisplayOrder,
                  parsedData: pdata,
                };
              }
            });

            setLayoutsList(templayoutslist);

            ///////////////////////////////////////////////
          } else {
            //alert("Seat Details array is empty");
          }
        } else {
          alert("Layout data array is empty");
        }
      } else {
        alert("Layout data is not in expected array format");
      }
    }

    // end of logic
  }, [
    allSeatDeatils,
    seatsBookedList,
    layoutsArrayData,
    selectedSeats,
    isSeatFlipped,
  ]);

  // useEffect(()=>{

  // },[layoutsArrayData]);

  useEffect(() => {
    // console.log(isSeatFlipped)
  }, [isSeatFlipped]);

  useEffect(() => {
    // console.log("inuseeffect layoutobject");
    // console.log(layoutObject);

    if (
      layoutObject &&
      layoutObject.seatBookedLists &&
      layoutObject.AllSeatDeatils &&
      layoutObject.LayoutStr
    ) {
      setAllSeatDeatils(layoutObject.AllSeatDeatils);
      setLayoutsArrayData(layoutObject.LayoutStr);
      setSeatBookedList(layoutObject.seatBookedLists);
      setIsLayoutDataLoading(false);

      //  const buttons = document.querySelectorAll('.auto-seat-flip-button');
      //  console.log('buttons');
      //  console.log(buttons);

      // Toggles the 'flipped' class every 3 seconds for this specific button
      setInterval(() => {
        setIsSeatFlipped((prevFlipped) => !prevFlipped);
      }, 2500);
    } else {
      //alert("All layout data not available");
    }
  }, [layoutObject]);

  useEffect(() => {
    // console.log("layouts list updated");
    // console.log(layoutsList);
  }, [layoutsList]);

  const handleTdClick = (id) => {
    // console.log(id);
    let pattern = `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`;
    // console.log(pattern);
    let extract_id = id.replace(pattern, "");
    // console.log(extract_id);

    //alert(layoutdata?.SeatIDs);
    // console.log(layoutdata?.SeatIDs);
    const seatObject = [...allSeatDeatils];
    let filteredSeat = seatObject.filter((item) => item.SeatID == extract_id);
    //alert("Seat Id is " + extract_id + "  the object is" + JSON.stringify(filteredSeat) );

    let seat_to_pick = filteredSeat?.length == 1 ? filteredSeat[0] : null;

    // console.log(selectedSeats.length);
    // if(selectedSeats.length > 5){

    // }else{
    //   console.log('asd');
    // }

    toggleSeatSelected(seat_to_pick);
    
  };

  // useEffect(()=>{
  //     console.log(selectedSeats);
  // },[selectedSeats]);

  // useEffect(() => {
  //   if(dailogInputData != null){
  //       fetchLayoutData();
  //   }

  // }, [dailogInputData]);

  // useEffect(() => {
  //   console.log(layoutdata);
  //   if (layoutdata) {

  //     console.log("parsing layout data...");
  //     console.log(layoutdata);
  //     // const parsedHtml = parse(layoutdata.rawLayoutStr);

  //     const rawString = layoutdata?.HTMLString.replace(
  //       /##TDIDPREFIX##/g,
  //       "ONWARD-" + layoutdata?.CoachID
  //     );
  //     setLtd(rawString);
  //     const options = {
  //       replace: (node) => {
  //         if (node.type == "tag" && node.name == "td") {
  //           //console.log(node);
  //           return (
  //             <td
  //               rowSpan={node.attribs.rowspan}
  //               colSpan={node.attribs.colspan}
  //               style={{ minWidth: "40px" }}
  //             >
  //              { node.attribs.id === "ONWARD-1tdSeatID_0"?<div> {node.children.map((p) => p.data)} </div>:
  //               <div
  //                 className={`${
  //                   node.attribs.id === "ONWARD-1tdSeatID_0"
  //                     ? ""
  //                     : node.attribs.rowspan == "3"
  //                     ? "seat seat-vertical"
  //                     : "seat"
  //                 }  ${
  //                   checkSeatSelected(node.attribs.id) ? "seat-checked" : ""
  //                 }`}
  //                 onClick={() => handleTdClick(node.attribs.id)}
  //               >
  //                 {node.children.map((p) => p.data)}
  //               </div>

  //               }
  //             </td>
  //           );
  //         }
  //       },
  //     };

  //     const pdata = parse(rawString, options);

  //     setParsedData(pdata);
  //   }
  // }, [layoutdata, selectedSeats]);

  const selectedSeatIds = useMemo(
    () => new Set(selectedSeats.map((s) => s.SeatID)),
    [selectedSeats],
  );

  useEffect(() => {
    // console.log(selectedSeatIds);
  }, [selectedSeatIds]);

  const bookedSeatIds = useMemo(
    () => new Set(seatsBookedList?.map((s) => s.SeatID)),
    [seatsBookedList],
  );

  const bookedSeatMap = useMemo(
    () => new Map(seatsBookedList?.map((s) => [s.SeatID, s])),
    [seatsBookedList],
  );

  const checkSeatSelected = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
        "",
      );
      // console.log(selectedSeatIds);
      // console.log(extract_id);
      // console.log("THis is the select seat ");
      return selectedSeatIds.has(Number(extract_id));
    },
    [selectedSeatIds],
  );

  const checkIsSeatBooked = useCallback(
    (id) => {
      const extract_id = id.replace(
        `${currentJourneyId}-${currentJourneyType}-${currentCoachId}-tdSeatID_`,
        "",
      );
      // console.log(extract_id);
      //return bookedSeatIds?.has(Number(extract_id));

      const seat = bookedSeatMap.get(Number(extract_id));

      if (seat) {
        return seat.Gender;
      }

      return null;
    },
    [bookedSeatIds],
  );

  function replaceProps(index) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const handleBoardingPointChange = (event) => {
    setSelectedBoarding(event.target.value);

    console.log("boarding point has changed");
    sendEventTobackend( "BoardingPointSelected", null , 1);
   
    const bobj = pickupPoints.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    //console.log(bobj);
    if (bobj.length > 0) {
      setSelectedBoardingName(bobj[0]);
    }

    if(dialogContentRef.current){
      dialogContentRef.current.scrollTop = 0;
    }
  };

  const handleDroppingPointChange = (event) => {
    setSelectedDropping(event.target.value);
    console.log("Dropping point has changed");
    sendEventTobackend( "DroppingPointSelected", null , 1);
    const bobj = droppingPoints.filter(
      (item) => item.BoardingPointID == event.target.value,
    );
    //console.log(bobj);
    if (bobj.length > 0) {
      //console.log("its length is more than 1");
      setSelectedDroppingName(bobj[0]);
    }
  };

  const toggleSeatSelected = (seat) => {


    setSelectedSeats((prev) =>
      prev?.some((s) => s.SeatID === seat.SeatID)
        ? prev.filter((item) => item.SeatID !== seat.SeatID)
        : prev.length > 5
          ? [...prev]
          : [...prev, seat],
    );

    sendEventTobackend( "SeatsSelected", null , 1);
  };

  // useEffect(()=>{
  //   console.log("Selected Boarding Point")
  //   console.log(selectedBoardingName);
  // },[selectedBoardingName]);

  // useEffect(()=>{
  //   console.log("Selected Dropping Point")
  //   console.log(selectedDroppingName);
  // },[selectedDroppingName]);

  useEffect(() => {
    // console.log(selectedSeats);
    // const ordered_Seats = selectedSeats.orderBy(selectedSeats,["SeatNumber"],["asc"]);
    // setSelectedSeats(ordered_Seats);
    if (selectedSeats.length > 5) {
      alert("You can select maximum of 6 seats");
    }
    let sub_sum = 0;
    // let discount = 0;
    // let gst = 0;
    selectedSeats.forEach((seat) => {
      sub_sum += seat.FARE;
    });

    setSubTotal(sub_sum);
    setGrandwithoutDisc(sub_sum);
    setDiscount((sub_sum * discountInPercent) / 100);
    setTotalGst((sub_sum * gstInpercent) / 100);

    const seatsWithSelectedAttribe = selectedSeats.map((item) => ({
      ...item,
      passangerName: null,
      age: null,
      gender: false,
    }));
    setUpdatedSeats(seatsWithSelectedAttribe);
  }, [selectedSeats]);

  useEffect(() => {
    setGrandTotal(0);
    setGrandwithoutDisc(subtotal);
    const total = subtotal - discount;
    if (gstInpercent != null) {
      const gst = (total * gstInpercent) / 100;
      setTotalGst(gst);
      const grand_total = total + gst;
      setGrandTotal(grand_total);
    }
  }, [selectedSeats, subtotal, discount, totalGst]);

  useEffect(() => {
    // console.log(updatedSeats);
  }, [updatedSeats]);


  

  // const handleGenderChange = (SeatNumber) => {

  // const currentValues = getValues(); // Get current form values
  //          console.log(currentValues);
  //          console.log(updatedSeats);

  //     const seatsGenderUpdated = updatedSeats.map((seat, index) =>

  //       seat.SeatNumber === SeatNumber
  //         ? {
  //             ...seat,
  //             gender: !seat.gender,
  //             passangerName: currentValues.passengers?.[index]?.passangerName,
  //             age: currentValues.passengers?.[index]?.age ,
  //           }
  //         : seat
  //     );

  //     setUpdatedSeats(seatsGenderUpdated);
  // };

  const handleGenderChange = (SeatNumber) => {
    const currentValues = getValues();

    sendEventTobackend( "GenderSelected", null , 1);

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: !seat.gender,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated); // Make sure to update the state
  };

  const handleMaleIconClick = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: false,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated);
  };

  const handleFeMaleIconClick = (SeatNumber) => {
    const currentValues = getValues();

    const seatsGenderUpdated = updatedSeats.map((seat, index) => {
      if (seat.SeatNumber === SeatNumber) {
        // Get passenger data from current form values
        const passengerData = currentValues.passengers?.[index] || {};

        return {
          ...seat,
          gender: true,
          passangerName: passengerData.passangerName || seat.passangerName,
          age: passengerData.age || seat.age,
        };
      }
      return seat;
    });

    setUpdatedSeats(seatsGenderUpdated);
  };

  useEffect(() => {
    // console.log(selectedGender);
  }, [selectedGender]);

  const handleBookNow = () => {
    // window.location.href = `${paymentUrl}`
    //window.location.replace(paymentUrl);
  };

  const inputRefs = useRef({});
  const onInvalid = (errors) => {
    // Find the first key in the errors object
    const firstErrorField = Object.keys(errors)[0];

    if (firstErrorField && inputRefs.current[firstErrorField]) {
      // Get the actual DOM element reference
      const element = inputRefs.current[firstErrorField];

      // Use the browser API to scroll it into view smoothly
      element.scrollIntoView({ behavior: "smooth", block: "center" });

      // Optional: focus the element as well
      element.focus();
    }
  };

  const onSubmit = (formData) => {

    sendEventTobackend( "BookNowCliked", null , 1);
    // formData contains: { mobile, email, passengers: [{name, age}, ...] }

    // Merge passenger form values into updatedSeats
    // const mergedSeats = updatedSeats.map((seat, idx) => ({
    //   ...seat,
    //   passangerName: formData.passengers?.[idx]?.passangerName ?? "",
    //   age: formData.passengers?.[idx]?.age ?? "",
    // }));

    //console.log(formData);
    // console.log(updatedSeats);

    console.log(globalData);

    const isLogged = globalData.SignedPassenger.IsPassengerSignedIn;
    const loggedMobileNo = globalData.SignedPassenger.SignedPassenger?.MobileNumber;

    console.log("global login Details");

    console.log(isLogged);
    console.log(loggedMobileNo);

    var deviceId = null;
    var deviceDaySession = null;

    if (window.SessionConstants.DEVICE_INFO_KEY) {
      deviceId = localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
    }

    if (window.SessionConstants.DEVICE_SESSION_KEY) {
      deviceDaySession = JSON.parse(
        localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY),
      );
    }

    if (!isTermsAndConditionsChecked) {
      alert("Please Check Terms & Conditions");
      return;
    }

    const mergedSeats = updatedSeats.map((seat, idx) => ({
      SeatName: seat.SeatNumber,
      SeatID: seat.SeatID,
      SeatFare: seat.FARE,
      SeatCUTFare: "0",
      SelectedName: formData.passengers?.[idx]?.passangerName ?? "",
      SelectedGender: seat.gender === true ? 2 : 1,
      SelectedAge: formData.passengers?.[idx]?.age ?? "",
    }));

    //setUpdatedSeats(mergedSeats);

    console.log("Form data GST Number is " + formData.GSTNumber);

    setContactDetails({ mobile: formData.mobile, email: formData.email });

    const payload = {
      GATEWAYNumber: 1,
      OnwardBookingDetails: {
        JType: 1,
        JourneyID: currentJourneyId,
        FromCityID: currentFromCityId,
        ToCityID: currentToCityId,
        BoardingPointID: selectedBoarding,
        DropingPointID: selectedDropping,
        ContactNumber: formData.mobile,
        ContactEmail: formData.email,
        GSTNumber: formData.GSTNumber != undefined ? formData.GSTNumber : "",
        seatsSelected: mergedSeats,
        TRVia: deviceType,
        MISBookingMode: MISBookingModeState,
        RegistrationUniqueID: deviceId || null,
        SessionUniqueID: deviceDaySession?.sessionId || null,
        IsPassengerSignedIn:isLogged,
        SignedPassengerMobileNumber: isLogged == 1 ?  loggedMobileNo != null || loggedMobileNo != undefined ? loggedMobileNo : "" : ""
      },
      ReturnBookingDetails: {
        JType: "0",
        JourneyID: "0",
        RegistrationUniqueID: deviceId || null,
        SessionUniqueID: deviceDaySession?.sessionId || null,
        IsPassengerSignedIn:isLogged,
        SignedPassengerMobileNumber: isLogged == 1 ?  loggedMobileNo != null || loggedMobileNo != undefined ? loggedMobileNo : "" : ""
      },

      
    };

  

    if(paths.alterSeatBookingInfo != '' && paths.alterSeatBookingInfo != null && paths.alterSeatBookingInfo != undefined){
      console.log("Alert seat booking info is " + paths.alterSeatBookingInfo);
      alert("Alert: " + paths.alterSeatBookingInfo);

      payload.seatBookingAlterRequest = JSON.parse(paths.alterSeatBookingInfo);
    }

    console.log(payload);
    // setFormPayload(payload);
    alert(JSON.stringify(payload));

    var selectors = null;

  

    if (
      PlatformDetector.isAndroidWebView() ||
      PlatformDetector.isIOSWebView()
    ) {
      selectors = {
        PGSelectionType: 1,
        PGTransactionVia: 1,
        GatewayNumber: 0,
        OrchestratorNumber: 3,
        isFromApp:
          PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()
            ? 1
            : 0,
      };
    } else {
      selectors = {
        PGSelectionType: 1,
        PGTransactionVia: 1,
        GatewayNumber: 0,
        OrchestratorNumber: 3,
        isFromApp:
          PlatformDetector.isAndroidWebView() || PlatformDetector.isIOSWebView()
            ? 1
            : 0,
      };
    }

    if (selectors != null) {
      setPgselectorUrl(getPgSelectorUrlString(selectors));
    }

    setIsLoading(true);

    axios
      .post(
        `${"/" + paths.BookSeatsTempEndPoint + "?" + getPgSelectorUrlString(selectors)}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      )
      .then((res) => {
        console.log(res.data);
        let response = res.data;
        if (response.Status) {
          // let res = JSON.parse(response.ResponseData);

          setTimeout(() => {
            //setIsLoading(false);
          }, 2000);

          
          const resultantdata = typeof response.ResponseData === "string" ? JSON.parse(response.ResponseData) : response.ResponseData;
          if(resultantdata.TEMPORDERID != null && resultantdata.TEMPORDERID != undefined){
              window.location.href = `${globalData.ServerBaseUrl + paths.redirectToPg + resultantdata.TEMPORDERID}`;
          }else{
            if(resultantdata.TransactionPassed !== undefined && resultantdata.TransactionPassed !== null) {
                const urldata = new URLSearchParams(resultantdata);
                window.location.replace(`${paths.postponeOrpreponeResultUrl}?transaction=${urldata.toString()}`);
            }else{
              alert(resultantdata.message );
            }
          }
          
        } else {
          setIsLoading(false);
          alert(response.Message);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        alert(err.toString());
        console.log(err);
      });

    // continue to payment
    // handleBookNow(); // or your window.location.replace(paymentUrl)
  };





//   const  sendEventTobackend = async (eventName, eventValue , eventFrom ) =>{
//       const TrviaAndMisData = MISBookingMode();
//       let deviceId = null;
//       let deviceDaySession = null

//       if(window.SessionConstants.DEVICE_INFO_KEY ){
//           deviceId =localStorage.getItem(window.SessionConstants.DEVICE_INFO_KEY);
//       }

//       if(window.SessionConstants.DEVICE_SESSION_KEY){
//          deviceDaySession = JSON.parse(localStorage.getItem(window.SessionConstants.DEVICE_SESSION_KEY)); 
//       }
       
//       console.log(eventName);
//       console.log(toSafeString(eventValue));
//       console.log(eventFrom);
//       console.log(deviceId);
//       console.log(deviceDaySession);


//       const payload = {
//         RegistrationUniqueID : deviceId,
//         SessionUniqueID :deviceDaySession.sessionId,
//         MobileNumber : "",
//         EventName : toSafeString(eventName),
//         TRVia : TrviaAndMisData.deviceType
//       }


//       const response = await axios.post('/send-event-to-backend', payload, {
//         headers: {
//           'Content-Type': 'application/json'
//         }
//       });

//       console.log(response);


//   }


//   function toSafeString(value) {
//   if (value === null || value === undefined) {
//     return "";
//   }

//   if (typeof value === "string") {
//     return value;
//   }

//   try {
//     return JSON.stringify(value);
//   } catch (e) {
//     return String(value);
//   }
// }








const tooltipContent = (
    <Box sx={{ width: 'auto',maxWith:'650px', p: 1.5 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 1, fontSize: '12px' }}>
        Fare Breakdown:
      </Typography>

      {/* Header Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
          gap: '2px',
          mb: 1,
          fontSize: '12px',
          fontWeight: 600,
        }}
      >
        <span>Seat</span>
        <span style={{ textAlign: 'right' }}>Fare</span>
        <span style={{ textAlign: 'right' }}>Disc(%)</span>
        <span style={{ textAlign: 'right' }}>Discount</span>
        <span style={{ textAlign: 'right' }}>Amount</span>
      </Box>

      {/* Seat Rows */}
      {updatedSeats?.map((item, idx) => (
        <Box
          key={idx}
          sx={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
            gap: '2px',
            fontSize: '12px',
            mb: 0.5,
          }}
        >
          <span>{item.SeatNumber}</span>
          <span style={{ textAlign: 'right' }}>₹ {item.FARE.toFixed(2) || 'N/A'}</span>
          <span style={{ textAlign: 'right' }}>{discountInPercent}%</span>
          <span style={{ textAlign: 'right' }}>₹ {(item.FARE * discountInPercent / 100).toFixed(2)}</span>
          <span style={{ fontWeight: 600, textAlign: 'right' }}>
            ₹ {(item.FARE - (item.FARE * discountInPercent / 100)).toFixed(2)}
          </span>
        </Box>
      ))}

      {/* Total Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
          gap: '8px',
          fontSize: '13px',
          fontWeight: 600,
          borderTop: '1px dashed #2D3FA8',
          pt: 1,
          mt: 1,
          mb: 0.5,
        }}
      >
        <span>Total</span>
        <span style={{ textAlign: 'right' }}>₹ {subtotal.toFixed(2)}</span>
        <span style={{ textAlign: 'right' }}>-</span>
        <span style={{ textAlign: 'right' }}>₹ {discount.toFixed(2)}</span>
        <span style={{ textAlign: 'right' }}>₹ {(subtotal - discount).toFixed(2)}</span>
      </Box>

      {/* GST Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
          gap: '8px',
          fontSize: '13px',
          mb: 0.5,
        }}
      >
        <span>GST</span>
        <span style={{ textAlign: 'right' }}> {gstInpercent}% </span>
        <span style={{ textAlign: 'right' }}> - </span>
        <span style={{ textAlign: 'right' }}>-</span>
        <span style={{ textAlign: 'right' }}>₹ {totalGst.toFixed(2)}</span>
      </Box>

      {/* Grand Total Row */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr',
          gap: '8px',
          fontSize: '13px',
          fontWeight: 700,
          borderTop: '1px dashed #2D3FA8',
          pt: 1,
        }}
      >
        <span>Grand Total</span>
        <span style={{ textAlign: 'right' }}>-</span>
        <span style={{ textAlign: 'right' }}>-</span>
        <span style={{ textAlign: 'right' }}>-</span>
        <span style={{ textAlign: 'right' }}>₹ {grandTotal.toFixed(2)}</span>
      </Box>
    </Box>
  );













  return (
    <>
      {/* <button onClick={() => setDailogOpen((prev) => (prev = !prev))}>
        open/close dailog
      </button> */}
      <Fragment>
        <Dialog
          fullWidth
          open={open}          // was dailogOpen
          onClose={handleClose}
          slots={{
            transition: Transition,
          }}
          PaperProps={{
            sx: {
              m: 0,
              position: "fixed",
              bottom: 0,
              left: 0,
              right: 0,
              width: "100vw",
              maxWidth: "100vw",
              height: "90vh",
              maxHeight: "90vh",
              overflowY: "hidden",
            },
          }}
        >
          <AppBar
            sx={{
              padding: "2px 10px",
              position: "relative",
              background: "#F4CC08",
              boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px",
            }}
          >
            <Toolbar
              sx={{
                background: "#F4CC08",
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <div>
                <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                  {dailogInputData?.bus.CoachExternal}
                </Typography>
                <Typography sx={{ color: "#3D18B5", fontWeight: "600" }}>
                  {" "}
                  <small>
                    {dailogInputData?.bus.BoardingCity +
                      "-" +
                      dailogInputData?.bus.DropCity}
                  </small>{" "}
                </Typography>
              </div>

              <div className="dialog-bus-time-duration">
                <div className="bus-timings">
                  <span>{dailogInputData?.bus.MBT}</span>
                  <span>{dailogInputData?.bus.MDT}</span>
                </div>
                <div className="bus-durations">
                  <div className="img-duration-content">
                    <span className="duration">
                      {" "}
                      {dailogInputData?.bus
                        ? dailogInputData?.bus.Duration
                        : ""}{" "}
                    </span>
                    <img src="/images/line_with_circle_purple.svg" />
                  </div>
                </div>
              </div>

              <div style={{ display: "flex", gap: "50px" }}>
                <div className="bus-date-time">
                  {globalData.isReturnJourneyExist ? (
                  
                      globalData.journeyType == "onward" ?
                      <>
                        <Typography
                          sx={{
                            color: "#3D18B5",
                            fontWeight: "400",
                            fontSize: "12px",
                          }}
                        >
                          Onward Journey
                          
                        </Typography>
                         <span>{onwardDateFormatWithMonthName}</span>
                        <span>{onwardDayName}</span>
                        
                      </>
                      :
                      <>
                        <Typography
                          sx={{
                            color: "#3D18B5",
                            fontWeight: "400",
                            fontSize: "12px",
                          }}
                        >
                          Return Journey
                        </Typography>
                        <span>{returnDateFormatWithMonthName}</span>
                        <span>{returnDayName}</span>
                      </>
                   
                  ) :(
                    <>
                       <span>{onwardDateFormatWithMonthName}</span>
                        <span>{onwardDayName}</span>
                    </>
                  )}
                </div>
                <IconButton
                  edge="start"
                  onClick={handleClose}
                  aria-label="close"
                  sx={{
                    color: "#2D3FA8",
                    border: "1px solid #2D3FA8",
                    borderRadius: "50%",
                    "&:hover": {
                      color: "#fff",
                      backgroundColor: "#2D3FA8",
                    },
                    height: "30px",
                    width: "30px",
                  }}
                >
                  <IoMdClose />
                </IconButton>
              </div>
            </Toolbar>
          </AppBar>

          <Box
            sx={{
              borderBottom: 1,
              borderColor: "#2D3FA8",
              borderWidth: "2px",
              padding: 0,
              marginTop: "-2px",
              height: "35px",
              maxHeight: "35px",
            }}
          >
            <Tabs
              value={tabValue}
              aria-label="basic tabs example"
              onChange={handleTabChange}
              centered={true}
              sx={tabsStyle}
              TabIndicatorProps={{ style: { display: "none" } }}
            >
              <Tab sx={tabstyles} label="View Seats" {...replaceProps(0)} />
              <Tab
                sx={tabstyles}
                label="Boarding / Dropping Point"
                {...replaceProps(1)}
              />
              <Tab
                sx={tabstyles}
                label="Passenger Information"
                {...replaceProps(2)}
              />
              <Tab sx={tabstyles} label="Bus Route" {...replaceProps(3)} />
              <Tab sx={tabstyles} label="About Bus" {...replaceProps(4)} />
            </Tabs>
          </Box>

          <DialogContent
            ref={dialogContentRef}
            sx={{
              m: 0,
              p: "5px",
              display: "flex",
              flex: 1,
              justifyContent: "center",
            }}
          >
            <div className="dialog-tabpanes-content">
              <CustomTabPanel value={tabValue} index={0}>
                {isLayoutDataLoading ? (
                  <SeatLayoutHorizontalSkeleton />
                ) : (
                  <div className="seat-layout-content">
                    <div>
                      <div
                        className={
                          layoutOrientation == 1
                            ? "seat-layout"
                            : "seat-layout-vertical"
                        }
                      >
                        {/* <div>{parsedData && parsedData}</div> */}
                        {layoutsList &&
                          layoutsList.length > 0 &&
                          layoutsList.map((layoutItem, index) => (
                            <div
                              key={index}
                              style={{ marginTop: "20px" }}
                              className={
                                layoutOrientation == 1
                                  ? "layout-deck-content"
                                  : "layout-deck-content-vertical"
                              }
                            >
                              <div className="busfront">
                                <div className="driver-seat">
                                  {layoutItem.DeckName === "Lower Deck" ? (
                                    <GiSteeringWheel
                                      size={20}
                                      className="steering-icon"
                                    />
                                  ) : (
                                    <i style={{ paddingLeft: "16px" }}>
                                      &nbsp;
                                    </i>
                                  )}
                                </div>
                                <div className="deck-name">
                                  {layoutItem.DeckName}
                                </div>
                              </div>
                              <div>
                                {layoutItem.parsedData && layoutItem.parsedData}
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>

                    <div className="seat-info">
                      <div className="seat-layout-seat-info">
                        <div className="seat-items-info-large">
                          <span> Available </span>
                          <div>
                            <div className="seat-info-empty-seat-large">
                              <div className="slot"></div>
                            </div>
                          </div>
                        </div>

                        <div className="seat-items-info-large">
                          <span> Selected </span>
                          <div>
                            <div className="seat-info-empty-seat-large selected-seat">
                              <div className="slot"></div>
                            </div>
                          </div>
                        </div>

                        <div className="seat-items-info-large">
                          <span> Booked </span>
                          <div>
                            <div className="seat-info-empty-seat-large booked-seat">
                              <div className="slot"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* <div
                className="dialog-bottom-group"
               >
                {selectedSeats?.length > 0 && (
                  <button
                    className="continue-button"
                    onClick={() => setTabValue(1)}
                  >
                    {" "}
                    Continue{" "}
                  </button>
                )}
              </div> */}
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={1}>
                <div className="dialog-board-drop-container">
                  <div className="dialog-boarding-points">
                    <h3 className="headings-main">Select Boarding Point</h3>
                    <small></small>

                    {pickupPoints &&
                      pickupPoints.map((item, index) => (
                        <div className="dialog-input-containers">
                          <div className="dialog-input-radio">
                            <div className="inputs-content">
                              <label
                                className="radio-label"
                                key={item.BoardingPointID + "-" + index}
                              >
                                <div>
                                  <input
                                    type="radio"
                                    name="boardings"
                                    value={item.BoardingPointID}
                                    id={item.BoardingPointID + "-" + index}
                                    checked={
                                      selectedBoarding === item.BoardingPointID
                                    }
                                    onChange={handleBoardingPointChange}
                                  />
                                  <span> {item.DepartureTime}</span>
                                </div>
                                   <abbr title={item.PointName}>
                                <span className="pointname" >
                                  {item.PointName}
                                </span>
                                </abbr> 
                              </label>
                            </div>

                            <div className="br-details" onClick={() => handleBoardingPointChange({ target: { value: item.BoardingPointID } })}>
                              <div className="left-content-br">
                                
                                <div className="content-bottom">
                                  {/* {item.ContactMobileNumber != "" ? (
                                    <div className="mobile-number">
                                      <a
                                        href={"tel:" + item.ContactMobileNumber}
                                      >
                                        <CiPhone />{" "}
                                        <>{item.ContactMobileNumber} </>{" "}
                                      </a>{" "}
                                      &nbsp;
                                    </div>
                                  ) : (
                                    ""
                                  )} */}

                                  

                                  <div className="icons-container">
                                    <a className="location-button" onClick={(e)=>{e.stopPropagation();}}  target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                       <CiLocationOn />
                                    </a>
                                    {/* <ContactPhone mobileNumber={item.ContactMobileNumber} /> */}
                                     
                                    {/* <span className="location-button">
                                     
                                      
                                    </span> */}
                                  </div>

                                   <ContactPhone mobileNumber={item.ContactMobileNumber} />
                                  
                                </div>
                              </div>

                              <div className="right-content-br" >
                                <span>
                                  {item.LandMark1 !== "" ? item.LandMark1 : ""}
                                </span>
                                <span>
                                  {item.LandMark2 !== "" ? item.LandMark2 : ""}
                                </span>
                                <span>
                                  {item.AddressLine1 !== ""
                                    ? item.AddressLine1
                                    : ""}
                                </span>
                                <span>
                                  {item.AddressLine2 !== ""
                                    ? item.AddressLine2
                                    : ""}
                                </span>
                                <span>
                                  {item.AddressLine3 !== ""
                                    ? item.AddressLine3
                                    : ""}
                                </span>
                               
                              </div>
                            </div>
                            <div className="br-address-lines">
                                 

                            </div>
                          </div>
                        </div>
                      ))}
                  </div>

                  <div className="dialog-dropping-points">
                    <h3 className="headings-main">Select Dropping Points</h3>
                    <small></small>
                    {droppingPoints &&
                      droppingPoints.map((item, index) => (
                        <div className="dialog-input-containers">
                          <div className="dialog-input-radio">
                            <div className="inputs-content-dropping">
                              <label
                                className="radio-label"
                                key={
                                  item.BoardingPointID +
                                  "-" +
                                  index +
                                  "dropping"
                                }
                              >
                                <abbr title={item.PointName}>
                                <span className="pointname" for={item.BoardingPointID + "-" + index}> 
                                  {item.PointName}
                                </span>
                                </abbr>
                                <div>
                                  <span> {item.ArrivalTime}</span>
                                  <input
                                    type="radio"
                                    name="droppings"
                                    value={item.BoardingPointID}
                                    id={item.BoardingPointID + "-" + index}
                                    checked={
                                      selectedDropping === item.BoardingPointID
                                    }
                                    onChange={handleDroppingPointChange}
                                  />
                                </div>
                              </label>
                            </div>

                            <div className="dr-details" onClick={() => handleDroppingPointChange({ target: { value: item.BoardingPointID } })}>
                              

                              <div className="right-content-br" >
                                <span>
                                  {item.LandMark1 !== "" ? item.LandMark1 : ""}
                                </span>
                                <span>
                                  {item.LandMark2 !== "" ? item.LandMark2 : ""}
                                </span>
                                <span>
                                  {item.AddressLine1 !== ""
                                    ? item.AddressLine1
                                    : ""}
                                </span>
                                <span>
                                  {item.AddressLine2 !== ""
                                    ? item.AddressLine2
                                    : ""}
                                </span>
                                <span>
                                  {item.AddressLine3 !== ""
                                    ? item.AddressLine3
                                    : ""}
                                </span>
                              </div>

                              <div className="left-content-br">
                                <div className="content-bottom">
                                  <ContactPhone mobileNumber={item.ContactMobileNumber} />
                                  <div className="icons-container" style={{paddingRight:"0px"}}>
                                    <a className="location-button" target="_blank" onClick={(e)=>{e.stopPropagation();}} href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                      <CiLocationOn />
                                    </a>

                                    {/* <span className="location-button">
                                      <TbView360Number />
                                    </span> */}
                                  </div>
                                  

                                  {/* {item.ContactMobileNumber != "" ? (
                                    <div className="mobile-number">
                                      <a
                                        href={"tel:" + item.ContactMobileNumber}
                                      >
                                        <CiPhone />{" "}
                                        <>{item.ContactMobileNumber} </>{" "}
                                      </a>{" "}
                                      &nbsp;
                                    </div>
                                  ) : (
                                    ""
                                  )} */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                <div></div>
              </CustomTabPanel>
              <CustomTabPanel value={tabValue} index={2}>
                <div className="passanger-detiales-content">
                  {selectedSeats?.length > 0 &&
                  selectedBoarding != null &&
                  selectedDropping != null ? (
                    <>
                      <div className="customer-info-table-content">
                        <div className="contact-details">
                          <h3 className="headings-main">Contact Details</h3>
                          <div className="divider"></div>
                          <div className="contact-details-card">
                            <div className="contact-details-form">
                              <div style={{ width: "100%" }}>
                                <Controller
                                  name="mobile"
                                  control={control}
                                  rules={{
                                    required: "Mobile number is required",
                                    pattern: {
                                      value: /^[0-9]{10}$/,
                                      message:
                                        "Enter a valid 10-digit mobile number",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <TextField
                                      {...field}
                                      // Capture the ref into our manual inputRefs map
                                      inputRef={(el) => {
                                        field.ref(el); // Still let RHF manage its own ref internally
                                        inputRefs.current.mobile = el; // Manually track it for our scroll logic
                                      }}
                                      onBlur={(e)=>{
                                        field.onBlur();
                                        const value = e.target.value;
                                        sendEventTobackend("ContactMobileNoTouched",null,1) 
                                      }}
                                                                            placeholder="Mobile Number *"
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      error={!!errors.mobile}
                                      helperText={errors.mobile?.message}
                                      inputProps={{
                                        maxLength: 10,
                                        autoComplete: "none",
                                      }}
                                      sx={{
                                        "& .MuiInputLabel-root": {
                                          fontSize: "13px",
                                          "&.Mui-focused": {
                                            color: "#2D3FA8",
                                          },
                                        },

                                        "& .MuiOutlinedInput-root": {
                                          maxHeight: "30px",

                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },

                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "",
                                            },

                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },
                                        },

                                        "& label.Mui-focused": {
                                          color: "#1F1F1F",
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </div>
                              <div style={{ width: "100%" }}>
                                <Controller
                                  name="email"
                                  control={control}
                                  rules={{
                                    required: "Email is required",
                                    pattern: {
                                      value: /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i,
                                      message: "Enter a valid email address",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <TextField
                                      {...field}
                                      inputRef={(el) => {
                                        field.ref(el); // Still let RHF manage its own ref internally
                                        inputRefs.current.email = el; // Manually track it for our scroll logic
                                      }}

                                      onBlur={(e)=>{
                                        field.onBlur();
                                        const value = e.target.value;
                                        sendEventTobackend("ContactEmailTouched",null,1) 
                                      }}
                                      placeholder="E-mail *"
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      error={!!errors.email}
                                      helperText={errors.email?.message}
                                      inputProps={{ autoComplete: "none" }}
                                      sx={{
                                        "& .MuiInputLabel-root": {
                                          fontSize: "13px",
                                          "&.Mui-focused": {
                                            color: "#2D3FA8",
                                          },
                                        },

                                        "& .MuiOutlinedInput-root": {
                                          maxHeight: "30px",

                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },

                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "",
                                            },

                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },
                                        },

                                        "& label.Mui-focused": {
                                          color: "#1F1F1F",
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </div>

                               <div style={{ width: "100%" }}>
                                <Controller
                                  name="GSTNumber"
                                  control={control}
                                  rules={{
                                    pattern: {
                                     value: /^[a-zA-Z0-9]{15}$/, 
                                    //  exact gst pattern match
                                    //  /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1}$/
                                      message:
                                        "Enter a valid 15-digit GST number",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <TextField
                                      {...field}
                                      // Capture the ref into our manual inputRefs map
                                      inputRef={(el) => {
                                        field.ref(el); // Still let RHF manage its own ref internally
                                        inputRefs.current.GSTNumber = el; // Manually track it for our scroll logic
                                      }}
                                      onBlur={(e)=>{
                                        field.onBlur();
                                        const value = e.target.value;
                                        sendEventTobackend("ContactGSTNumberTouched",null,1) 
                                      }}
                                                                            placeholder="GST Number"
                                      variant="outlined"
                                      size="small"
                                      fullWidth
                                      error={!!errors.GSTNumber}
                                      helperText={errors.GSTNumber?.message}
                                      inputProps={{
                                        maxLength: 15 ,
                                        autoComplete: "none",
                                      }}
                                      sx={{
                                        "& .MuiInputLabel-root": {
                                          fontSize: "13px",
                                          "&.Mui-focused": {
                                            color: "#2D3FA8",
                                          },
                                        },

                                        "& .MuiOutlinedInput-root": {
                                          maxHeight: "30px",

                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },

                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "",
                                            },

                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },
                                        },

                                        "& label.Mui-focused": {
                                          color: "#1F1F1F",
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </div>
                            </div>
                            <small
                              style={{ color: "#2D3FA8", paddingLeft: "0px" }}
                            >
                              Journey & Ticket Details will be sent these
                              details!
                            </small>
                          </div>
                        </div>
                      </div>

                      <div className="passenger-details">
                        <h3 className="headings-main">Passanger Details</h3>
                        <div className="divider"></div>

                        <div className="table-header">
                          <div className="column-title"> Sl. No </div>
                          <div className="column-title"> Seat </div>
                          <div className="column-title"> Name </div>
                          <div className="column-title"> Age </div>
                          <div className="column-title"> Gender </div>
                          <div className="column-title price"> Price </div>
                        </div>

                        <div className="table-body">
                          {/* map over updatedSeats to render one row per passenger and wire to form passengers[index] */}
                          {updatedSeats?.map((item, index) => (
                            <div
                              className="filed-row"
                              key={item.SeatID ?? index}
                            >
                              <div className="field"> {index + 1} </div>
                              <div className="field"> {item.SeatNumber} </div>

                              {/* PASSENGER NAME */}
                              <div className="field">
                                <Controller
                                  name={`passengers.${index}.passangerName`}
                                  control={control}
                                  rules={{
                                    required: "Name is required",
                                    pattern: {
                                      value: /^[a-zA-Z ]*$/,
                                      message: "Enter valid Name",
                                    },
                                    minLength: {
                                      value: 2,
                                      message: "Enter a valid name",
                                    },
                                  }}
                                  render={({ field }) => (
                                    <TextField
                                      {...field}
                                      inputRef={(el) => {
                                        field.ref(el); // Still let RHF manage its own ref internally
                                        inputRefs.current.passangerName = el; // Manually track it for our scroll logic
                                      }}
                                      placeholder="Passenger Name *"
                                      variant="outlined"
                                      size="small"
                                      inputProps={{ autoComplete: "none" }}
                                      onChange={(e) => {
                                        field.onChange(e); // update react-hook-form
                                        const newSeats = [...updatedSeats];
                                        if (newSeats[index]) {
                                          newSeats[index].passangerName =
                                            e.target.value;
                                          setUpdatedSeats(newSeats); // sync with updatedSeats
                                        }
                                        
                                      }}

                                      onBlur={(e)=>{
                                        field.onBlur();
                                        const value = e.target.value;
                                        sendEventTobackend("PassengerNameTouched",null,1) 
                                      }}
                                      error={
                                        !!(
                                          errors.passengers &&
                                          errors.passengers[index]
                                            ?.passangerName
                                        )
                                      }
                                      helperText={
                                        errors.passengers &&
                                        errors.passengers[index]?.passangerName
                                          ?.message
                                      }
                                      fullWidth
                                      sx={{
                                        "& .MuiInputLabel-root": {
                                          fontSize: "13px",
                                          "&.Mui-focused": {
                                            color: "#2D3FA8",
                                          },
                                        },

                                        "& .MuiOutlinedInput-root": {
                                          maxHeight: "30px",

                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },

                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "",
                                            },

                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },
                                        },

                                        "& label.Mui-focused": {
                                          color: "#1F1F1F",
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </div>

                              {/* PASSENGER AGE */}
                              <div className="field">
                                <Controller
                                  name={`passengers.${index}.age`}
                                  control={control}
                                  rules={{
                                    required: "Age is required",
                                    pattern: {
                                      value: /^[0-9]{1,3}$/,
                                      message: "Enter valid age",
                                    },
                                    validate: (v) =>
                                      (Number(v) > 0 && Number(v) < 130) ||
                                      "Enter valid age",
                                  }}
                                  render={({ field }) => (
                                    <TextField
                                      {...field}
                                      inputRef={(el) => {
                                        field.ref(el); // Still let RHF manage its own ref internally
                                        inputRefs.current.age = el; // Manually track it for our scroll logic
                                      }}
                                      placeholder="Age *"
                                      variant="outlined"
                                      size="small"
                                      error={
                                        !!(
                                          errors.passengers &&
                                          errors.passengers[index]?.age
                                        )
                                      }
                                      helperText={
                                        errors.passengers &&
                                        errors.passengers[index]?.age?.message
                                      }
                                      inputProps={{
                                        inputMode: "numeric",
                                        pattern: "[0-9]*",
                                        maxLength: 3,
                                        autoComplete: "none",
                                      }}
                                      onChange={(e) => {
                                        field.onChange(e); // update react-hook-form
                                        const newSeats = [...updatedSeats];
                                        if (newSeats[index]) {
                                          newSeats[index].age = e.target.value;
                                          setUpdatedSeats(newSeats); // sync with updatedSeats
                                        }
                                        
                                      }}
                                      onBlur={(e)=>{
                                        field.onBlur();
                                        const value = e.target.value;
                                        sendEventTobackend("PassengerAgeTouched",null,1) 
                                      }}
                                      fullWidth
                                      sx={{
                                        "& .MuiInputLabel-root": {
                                          fontSize: "13px",
                                          "&.Mui-focused": {
                                            color: "#2D3FA8",
                                          },
                                        },

                                        "& .MuiOutlinedInput-root": {
                                          maxHeight: "30px",

                                          "& .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },

                                          "&:hover .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "",
                                            },

                                          "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                            {
                                              borderColor: "#2D3FA8",
                                              borderWidth: "1px",
                                            },
                                        },

                                        "& label.Mui-focused": {
                                          color: "#1F1F1F",
                                        },
                                      }}
                                    />
                                  )}
                                />
                              </div>

                              {/* GENDER (keeps your current UI + handlers) */}
                              <div className="gender">
                                <div
                                  className="gender-switch-container"
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: 8,
                                  }}
                                >
                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      color: "#3D18B5",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleMaleIconClick(item.SeatNumber)
                                    }
                                  >
                                    <img
                                      src="/images/MaleTransparent_1.png"
                                      style={{
                                        width: "34px",
                                        height: "34px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  </span>

                                  <FormControlLabel
                                    control={
                                      <Switch
                                        checked={item.gender}
                                        onChange={() =>
                                          handleGenderChange(item.SeatNumber)
                                        }
                                        sx={{
                                          "& .MuiSwitch-thumb": {
                                            backgroundColor: item.gender
                                              ? "#ff1493"
                                              : "#2D3FA8",
                                          },
                                          "& .MuiSwitch-track": {
                                            backgroundColor: "#F4CC13",
                                            opacity: 0.4,
                                          },
                                        }}
                                      />
                                    }
                                  />

                                  <span
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      cursor: "pointer",
                                    }}
                                    onClick={() =>
                                      handleFeMaleIconClick(item.SeatNumber)
                                    }
                                  >
                                    <img
                                      src="/images/femaleTransparent1.png"
                                      style={{
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "4px",
                                      }}
                                    />
                                  </span>
                                </div>
                              </div>

                              <div className="field price">
                                &#8377; {item.FARE}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>

                      <div className="divider" style={{marginTop:"10px"}}></div>


     

                   
                      

                      
                      <div className="divider"></div>

                      <div className="br-dr-container">
                        <div className="passenger-card-container-small">
                          <div className="card-top-button-br-dr">
                            Boarding Point
                          </div>
                          <div className="passenger-card-small">
                            <div className="boarding-dropping-info">
                              <div>
                                <div className="points">
                                  <div className="left">
                                    <span className="pointname">
                                      {" "}
                                      {selectedBoardingName
                                        ? selectedBoardingName.PointName
                                        : ""}{" "}
                                    </span>
                                  </div>
                                  <div className="right">
                                    <span className="pointname">
                                      {" "}
                                      {selectedBoardingName
                                        ? selectedBoardingName.DepartureTime
                                        : ""}{" "}
                                    </span>
                                  </div>
                                </div>

                                <div className="dr-details">
                                  

                                  <div className="right-content-br">
                                    <span>
                                      {selectedBoardingName?.AddressLine2
                                        .LandMark1 !== ""
                                        ? selectedBoardingName?.LandMark1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.LandMark2 !== ""
                                        ? selectedBoardingName?.LandMark2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.AddressLine1 !== ""
                                        ? selectedBoardingName?.AddressLine1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.AddressLine2 !== ""
                                        ? selectedBoardingName?.AddressLine2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedBoardingName?.AddressLine3 !== ""
                                        ? selectedBoardingName?.AddressLine3
                                        : ""}
                                    </span>
                                  </div>


                                   <div className="left-content-br">
                                    <div className="content-bottom">
                                      <div className="icons-container">
                                        <a className="location-button" onClick={(e)=>{e.stopPropagation();}} target="_blank" href={'/show-pickup-dropping?lat=15.350417344847436&lon=75.1391945019891'}>
                                          <CiLocationOn />
                                        </a>

                                        {/* <span className="location-button">
                                          <TbView360Number />
                                        </span> */}
                                      </div>

                                      <ContactPhone mobileNumber={ selectedBoardingName?.ContactMobileNumber} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="passenger-card-container-small">
                          <div className="card-top-button-br-dr">
                            Dropping Point
                          </div>
                          <div className="passenger-card-small">
                            <div className="boarding-dropping-info">
                              <div>
                                <div className="points">
                                  <div className="left">
                                    <span className="pointname">
                                      {" "}
                                      {selectedDroppingName
                                        ? selectedDroppingName.PointName
                                        : ""}{" "}
                                    </span>
                                  </div>
                                  <div className="right">
                                    <span className="pointname">
                                      {" "}
                                      {selectedDroppingName
                                        ? selectedDroppingName.ArrivalTime
                                        : ""}{" "}
                                    </span>
                                  </div>
                                </div>

                                <div className="dr-details">
                                  

                                  <div className="right-content-br">
                                    <span>
                                      {selectedDroppingName?.AddressLine2
                                        .LandMark1 !== ""
                                        ? selectedDroppingName?.LandMark1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.LandMark2 !== ""
                                        ? selectedDroppingName?.LandMark2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.AddressLine1 !== ""
                                        ? selectedDroppingName?.AddressLine1
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.AddressLine2 !== ""
                                        ? selectedDroppingName?.AddressLine2
                                        : ""}
                                    </span>
                                    <span>
                                      {selectedDroppingName?.AddressLine3 !== ""
                                        ? selectedDroppingName?.AddressLine3
                                        : ""}
                                    </span>
                                  </div>






                                  <div className="left-content-br">
                                    <div className="content-bottom">
                                      
                                      
                                      <ContactPhone mobileNumber={selectedDroppingName?.ContactMobileNumber} />
                                      
                                      <div className="icons-container">
                                        <span className="location-button">
                                          <CiLocationOn />
                                        </span>

                                        {/* <span className="location-button">
                                          <TbView360Number />
                                        </span> */}
                                      </div>

                                      {/* {selectedDroppingName?.ContactMobileNumber !==
                                      "" ? (
                                        <div className="mobile-number">
                                          <a
                                            href={
                                              "tel:" +
                                              selectedDroppingName?.ContactMobileNumber
                                            }
                                          >
                                            <CiPhone />{" "}
                                            <>
                                              {
                                                selectedDroppingName?.ContactMobileNumber
                                              }{" "}
                                            </>{" "}
                                          </a>{" "}
                                          &nbsp;
                                        </div>
                                      ) : (
                                        ""
                                      )} */}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="payment-details-new">
                        <h3 className="headings-main">Payment Details</h3>
                        <div className="divider"></div>

                        <div className="payment-row">
                          <div className="perticulars"> Sub Total</div>
                          <div className="perticulars-amount">
                            {" "}
                            &#8377; {subtotal.toFixed(2)}
                          </div>
                        </div>

                        <div
                          className="payment-row"
                          style={{
                            borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                          }}
                        >
                          <div className="perticulars"> Discount </div>
                          <div className="perticulars-amount">
                            {" "}
                            - &#8377; {discount.toFixed(2)}
                          </div>
                        </div>

                        <div
                          className="payment-row"
                          style={{
                            borderTop: "1px solid rgba(244, 203, 19, 0.22)",
                          }}
                        >
                          <div className="perticulars">
                            {" "}
                            GST ( {gstInpercent} % ){" "}
                          </div>
                          <div className="perticulars-amount">
                            {" "}
                            &#8377; {totalGst.toFixed(2)}
                          </div>
                        </div>
                        <div className="divider"></div>
                        <div className="payment-grand-row">
                          <div className="perticulars"> Grand Total </div>
                          <div className="perticulars-amount">
                            {" "}
                            &#8377; {grandTotal.toFixed(2)}
                          </div>
                        </div>
                      </div>


                     









                      <div style={{marginTop:"10px"}}>
                        <label>
                          <input
                            type="checkbox"
                            onClick={(e) => {
                              setIsTermsAndConditionsChecked(e.target.checked);
                            }}
                          />{" "}
                          &nbsp;&nbsp; By Clicking on Book Now, I accept Terms &
                          Conditions, Privacy Policy
                        </label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="unselected">
                        <span>
                          {" "}
                          Please Select Seats,Boarding and Dropping Points
                        </span>
                        <button onClick={() => setTabValue(0)}>
                          {" "}
                          Select Seats,Boarding & Dropping Points
                        </button>
                      </div>
                    </>
                  )}
                </div>
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={3}>
                <h2>About Bus</h2>
              </CustomTabPanel>

              <CustomTabPanel value={tabValue} index={4}>
                <h2>About Bus</h2>
              </CustomTabPanel>
            </div>
          </DialogContent>
          <DialogActions
            sx={{
              borderTop: "2px solid #2D3FA8;",
              height: "60px",
              maxHeight: "60px",
            }}
          >
            <div className="dialog-footer">
              <div>
                {updatedSeats?.length > 0 && (
                  <div className="show-selected-seats">
                    {
                      <>
                        <div className="selected-seat-list">
                          <span>Selected Seats </span>
                          <div className="seat-selected-chip-container">
                            {updatedSeats?.map((item) => (
                              <div
                                className="selected-seat-chip"
                                style={
                                  item.gender
                                    ? { backgroundColor: "#FFC0CB" }
                                    : {
                                        backgroundColor: "#2D3FA8",
                                        color: "#fff",
                                      }
                                }
                              >
                                {" "}
                                {item.SeatNumber}
                              </div>
                            ))}
                          </div>
                        </div>
                      </>
                    }
                  </div>
                )}
              </div>

              {selectedSeats.length > 0 && (
                <div className="grand-total-footer">
                  <span className="gt-label">Grand Total</span>
                  <span className="gt-amount">
                    {" "}
                    <del>
                      &#8377;{" "}
                      {(
                        grandwithoutDisc +
                        (grandwithoutDisc * gstInpercent) / 100
                      ).toFixed(2)}
                    </del>
                  </span>{" "}
                  &nbsp;
                  <span className="gt-amount"> &#8377; {grandTotal} </span>






                  <Tooltip
                        title={tooltipContent}
                        arrow
                        placement="top"
                        slotProps={{
                          popper: {
                            modifiers: [
                              {
                                name: 'offset',
                                options: {
                                  offset: [0, 10],
                                },
                              },
                            ],
                          },
                          tooltip: {
                            sx: {
                              bgcolor: '#ffffff',
                              color: '#333',
                              boxShadow: '0 2px 10px rgba(0,0,0,0.2)',
                              fontSize: '12px',
                              border: '1px solid #e0e0e0',
                              borderRadius: '4px',
                              width:'100%',
                              minWidth:"500px",
                              p: 0,
                            },
                          },
                        }}
                      >
                        <MdInfo
                          style={{
                              fontSize: '18px',
                              cursor: 'pointer',
                              color: '#2D3FA8',
                            }}
                            onMouseEnter={(e) => e.target.style.color = '#F0C800'}
                            onMouseLeave={(e) => e.target.style.color = '#2D3FA8'}

                        />
                      </Tooltip>
















                </div>
              )}

              <div>
                <div>
                  {tabValue == 0 && (
                    <div className="dialog-bottom-group">
                      <button
                        className="continue-button"
                        onClick={() => setTabValue(1)}
                        disabled={selectedSeats?.length <= 0}
                      >
                        <span>Continue To Boarding/Dropping Points</span>
                        <span>
                          {" "}
                          <MdArrowForward />{" "}
                        </span>
                      </button>
                    </div>
                  )}
                </div>

                <div>
                  {tabValue == 1 && (
                    <div className="dialog-bottom-group">
                      <div className="dialog-bottom-group">
                        <button
                          className="back-button"
                          onClick={() => setTabValue(0)}
                        >
                          <span>
                            <MdArrowBack />
                          </span>
                          <span>Back</span>
                        </button>
                        <button
                          className="continue-button"
                          onClick={() => setTabValue(2)}
                          disabled={
                            !(
                              selectedBoarding != null &&
                              selectedDropping != null
                            )
                          }
                        >
                          {" "}
                          <span>Continue Fill Passanger Details</span>{" "}
                          <span>
                            {" "}
                            <MdArrowForward />{" "}
                          </span>{" "}
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  {tabValue == 2 && (
                    <div className="dialog-bottom-group">
                      <div className="dialog-bottom-group">
                        <button
                          className="back-button"
                          onClick={() => setTabValue(1)}
                        >
                          {" "}
                          <span>
                            <MdArrowBack />
                          </span>{" "}
                          <span>Back</span>{" "}
                        </button>
                        <button
                          className={`continue-button ${isLoading ? "loading" : ""}`}
                          onClick={handleSubmit(onSubmit, onInvalid)}
                          disabled={!isTermsAndConditionsChecked || isLoading}
                        >
                          <span class="button-spinner"></span>
                          <span> Book Now </span>
                          <span>
                            <MdArrowForward />
                          </span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </DialogActions>
        </Dialog>

        <form
          ref={formref}
          action={"/" + paths.BookSeatsTempEndPoint}
          method="POST"
          style={{ display: "none" }}
        >
          <input value={JSON.stringify(frompayload)} name="form_payload" />
        </form>
      </Fragment>
      <ComponentLevelLoader isLoading={isLoading} />
    </>
  );
};

export default JourneyDailog;
